<div aria-live="assertive" class="z-index-layer pointer-events-none fixed inset-0 flex items-end px-4 py-6 sm:items-start sm:p-6" *ngIf="toggler" [ngClass]="{'transform ease-out duration-300 transition':showToast, 'transition ease-in duration-100': !showToast, 'translate-y-2 opacity-0 sm:translate-y-0 ': animation, 'sm:translate-x-2 translate-y-0 opacity-100 sm:translate-x-0': !animation}">
    <div class="flex w-full flex-col items-center space-y-4 sm:items-end">
      <!--
        Notification panel, dynamically insert this into the live region when it needs to be displayed
  
        Entering: "transform ease-out duration-300 transition"
          From: "translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
          To: "translate-y-0 opacity-100 sm:translate-x-0"
        Leaving: "transition ease-in duration-100"
          From: "opacity-100"
          To: "opacity-0"
      -->
      <div class="pointer-events-auto mt-28 w-full max-w-sm overflow-hidden cursor-pointer rounded-lg bg-white shadow-lg ring-1 ring-black ring-opacity-5" *ngIf="additionalData?.action_type !== 'STREAM_CHAT' && additionalData?.action_type !== 'CHAT' && messageData?.type !== 'CALLER' && messageData?.type !== 'FAILED'" (click)="navigateTo(additionalData?.action_type, additionalData?.redirect_to)">
        <div class="p-4">
          <div class="flex items-center">
            <div class="flex-shrink-0 rounded-full px-3.5 py-3 bg-primary-50 dark:bg-primary" *ngIf="additionalData">
              <!-- Heroicon name: outline/check-circle -->
              <em *ngIf="!(additionalData?.action_type === 'ROUTE')"
                  [ngClass]="getIconClass(additionalData?.action_type)" class="text-3xl font-medium"></em>
              <img *ngIf="additionalData?.action_type === 'ROUTE'"
                  src="/assets/images/svgs/routes_notifications.svg" alt="" loading="lazy"
                  class="font-medium w-8 h-8 rounded-full text3xl">
            </div>
            <div class="flex-shrink-0" *ngIf="!additionalData">
              <svg class="h-6 w-6 text-green-400" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
                <path stroke-linecap="round" stroke-linejoin="round" d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </div>
            <div class="ml-3 w-0 flex-1 pt-0.5">
              <p class="text-base font-medium text-gray-900">{{messageData?.title}}</p>
              <p class="mt-1 text-base text-gray-500">{{messageData?.body}}</p>
            </div>
            <div class="ml-4 flex flex-shrink-0">
              <button type="button" (click)="closeToast($event)" class="inline-flex rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none">
                <span class="sr-only">{{'close.text' | translate}}</span>
                <!-- Heroicon name: mini/x-mark -->
                <svg class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                  <path d="M6.28 5.22a.75.75 0 00-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 101.06 1.06L10 11.06l3.72 3.72a.75.75 0 101.06-1.06L11.06 10l3.72-3.72a.75.75 0 00-1.06-1.06L10 8.94 6.28 5.22z" />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="pointer-events-auto mt-28 flex w-full max-w-md rounded-lg bg-white shadow-lg ring-1 ring-black ring-opacity-5"  *ngIf="additionalData?.action_type === 'CHAT'" (mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeave()">
        <div class="w-0 flex-1 p-4">
          <div class="flex items-start">
            <div class="flex-shrink-0 pt-0.5">
              <span class="relative inline-block">
                <img class="h-10 w-10 rounded-full" [src]="additionalData?.sender_profile_pic" alt="">
                <span class="absolute bottom-0 right-0 block translate-y-1/3 translate-x-1/3 transform rounded-full border-2 border-white">
                  <span class=" h-5 w-5 rounded-full bg-indigo-500 flex justify-center items-center">
                    <i class="ti ti-mail text-white text-md"></i>
                  </span>
                </span>
              </span>
            </div>
            <div class="ml-3 w-0 flex-1">
              <p class="text-base font-medium text-gray-900">{{additionalData?.sender_name}}</p>
              <p class="mt-1 text-base text-gray-500 mx-0.5 max-w-md truncate">{{messageData?.body}}</p>
            </div>
          </div>
        </div>
        <div class="flex border-l border-gray-200 cursor-pointer">
          <button (click)="navigateTo('JOB', additionalData?.redirect_to); openMessageTab()" type="button" class="flex w-full items-center justify-center rounded-none rounded-r-lg border border-transparent p-4 text-sm font-medium text-indigo-600 hover:text-indigo-500 focus:outline-none">{{'text.reply' | translate}}</button>
        </div>
      </div>

      <!-- Stream Chat Notification -->
      <div class="pointer-events-auto mt-28 flex w-full max-w-md rounded-lg bg-white shadow-lg ring-1 ring-black ring-opacity-5"
           *ngIf="additionalData?.action_type === 'STREAM_CHAT'"
           (mouseenter)="onMouseEnter()"
           (mouseleave)="onMouseLeave()">
        <div class="w-0 flex-1 p-4">
          <div class="flex items-start">
            <div class="flex-shrink-0 pt-0.5">
              <span class="relative inline-block">
                <img class="h-10 w-10 rounded-full" [src]="additionalData?.sender_profile_pic" alt="">
                <span class="absolute bottom-0 right-0 block translate-y-1/3 translate-x-1/3 transform rounded-full border-2 border-white">
                  <span class="h-5 w-5 rounded-full bg-indigo-500 flex justify-center items-center">
                    <i class="ti ti-message text-white text-md"></i>
                  </span>
                </span>
              </span>
            </div>
            <div class="ml-3 w-0 flex-1">
              <p class="text-base font-medium text-gray-900">{{additionalData?.sender_name}}</p>
              <p class="mt-1 text-base text-gray-500 mx-0.5 max-w-md truncate" [innerHTML]="messageData?.body"></p>
            </div>
          </div>
        </div>
        <div class="flex border-l border-gray-200 cursor-pointer">
          <button (click)="navigateTo('STREAM_CHAT', messageData?.additional_data)"
                  type="button"
                  class="flex w-full items-center justify-center rounded-none rounded-r-lg border border-transparent p-4 text-sm font-medium text-indigo-600 hover:text-indigo-500 focus:outline-none">
            {{'text.reply' | translate}}
          </button>
        </div>
      </div>

      @if(messageData?.type === 'CALLER' && additionalData?.messageType !== 'CALL') {
        <div class="pointer-events-auto mt-28 w-full max-w-sm overflow-hidden cursor-pointer rounded-lg bg-white shadow-lg ring-1 ring-black ring-opacity-5"
          (click)="navigateToCall(messageData)">
          <div class="p-4">
            <div class="flex items-center">
              <div class="flex-shrink-0 rounded-full px-3.5 py-2 bg-[#F5F7F9]" *ngIf="additionalData">
                <!-- Heroicon name: outline/check-circle -->
                <em [ngClass]="getIconClass('ZUPER_CONNECT')" class="text-3xl font-medium"></em>
              </div>
              <div class="ml-3 w-0 flex-1 pt-0.5">
                <p class="text-base font-medium text-[#252A31]">{{'text.new_message' | translate}}</p>
                <p class="mt-1 text-sm text-gray-500 line-clamp-3" id="messageText">
                  <span class="font-medium text-[#252A31]" id="customerName">
                    {{ additionalData?.customer?.customerName || formatPhoneNumber(additionalData?.customer?.number) ?? '' }}
                  </span>
                  <span class="ml-1" *ngIf="additionalData?.customer?.number_type">
                    <i class="text-lg" 
                       [ngClass]="{
                         'ti ti-home': additionalData?.customer?.number_type === 'HOME',
                         'ti ti-device-mobile': additionalData?.customer?.number_type === 'MOBILE',
                         'ti ti-briefcase': additionalData?.customer?.number_type === 'WORK'
                       }">
                    </i>
                  </span> :
                  <span class="font-normal text-[#4F5E71]">
                    {{ additionalData?.message ?? '' }}
                  </span>
                </p>
              </div>
              <div class="ml-4 flex flex-shrink-0">
                <button type="button" (click)="closeToast($event)" class="inline-flex rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none">
                  <span class="sr-only">{{'close.text' | translate}}</span>
                  <!-- Heroicon name: mini/x-mark -->
                  <svg class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                    <path d="M6.28 5.22a.75.75 0 00-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 101.06 1.06L10 11.06l3.72 3.72a.75.75 0 101.06-1.06L11.06 10l3.72-3.72a.75.75 0 00-1.06-1.06L10 8.94 6.28 5.22z" />
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>
      } 
      @if(messageData?.type === 'FAILED' && additionalData?.messageType === 'SMS') {
        <div class="pointer-events-auto mt-28 w-full max-w-sm overflow-hidden cursor-pointer rounded-lg bg-white shadow-lg ring-1 ring-black ring-opacity-5">
          <div class="p-4">
            <div class="flex items-center">
              <div class="flex-shrink-0 rounded-full px-3.5 py-2 bg-red-50">
                <em class="ti ti-alert-triangle text-3xl font-medium text-red-500"></em>
              </div>
              <div class="ml-3 w-0 flex-1 pt-0.5">
                <p class="text-base font-semibold text-red-500">{{'text.message_failed' | translate}}</p>
                <p class="text-md font-medium text-[#252A31]">{{ additionalData?.conversation?.error_reason  | translate}}</p>
                <p class="mt-1 text-sm text-gray-500 line-clamp-3">
                  <span class="font-normal text-[#4F5E71]" [innerHTML]="additionalData?.conversation?.message ?? ''">
                  </span>
                </p>
              </div>
              <div class="ml-4 flex flex-shrink-0">
                <button type="button" (click)="closeToast($event)" class="inline-flex rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none">
                  <span class="sr-only">{{'close.text' | translate}}</span>
                  <!-- Heroicon name: mini/x-mark -->
                  <svg class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                    <path d="M6.28 5.22a.75.75 0 00-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 101.06 1.06L10 11.06l3.72 3.72a.75.75 0 101.06-1.06L11.06 10l3.72-3.72a.75.75 0 00-1.06-1.06L10 8.94 6.28 5.22z" />
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>
      } 

    </div>
  </div>